module.exports = __webpack_public_path__ + "1ec7d8024693e239706a06552f3a5c1e.png";